import { jf } from "./job-model";

// ── The JobSchedule model: a NAMED MAP of fields ────────────────────────────
// A JobSchedule is a TIMING TRIGGER for a job ("fire job_uid on this schedule").
// Everything about WHAT runs and HOW it's monitored lives on the parent Job —
// the schedule carries only the expression + an enabled flag (per JobSchedule.cube.zoo).
//
// UI-free (only depends on FieldDef via jf) — same layering as JobDef.
export const ScheduleDef = {
  name: jf({ name: "name", label: "Name", type: "string", required: true }),
  description: jf({ name: "description", label: "Description", type: "string" }),
  job_uid: jf({ name: "job_uid", label: "Job", type: "enum", required: true }),
  schedule_expr: jf({ name: "schedule_expr", label: "Schedule", type: "string", required: true }),
  enabled: jf({ name: "enabled", label: "Enabled", type: "boolean", required: true }),
  /** what a fire does: "run" (the default) or "restart" (a daemon job's restart) */
  event_kind: jf({ name: "event_kind", label: "Event kind", type: "string", hidden: true }),
};
